export const TOGGLE_SELECTION = {
  pt: "Selecionar todas / Desmarcar todas",
};

export const ALL = {
  pt: "Todos",
  es: "Todos",
  en: "All",
};
